export const aItems = [
  {
    "id": "A1",
    "name": "大邱大学",
    "info": "大邱大学位于大韩民国庆尚北道庆山市，为本科全日制大学。学校建立之初，以特殊教育和社会福利教育为主，至今仍然是学校的特色专业。",
    "end_date": "当期7月4日截止",
    "Dormitory": "1.国际馆双人间：4500（独浴）           2.飞虎馆双人间：3900（公浴）",
    "B_Fee": "语言课程7300",
    "B_Fee_2": "翻译费3400",
    "end": ""
  },
  {
    "id": "A2",
    "name": "东国大学",
    "info": "东国大学是韩国首尔顶尖私立综合大学之一，校本部位于韩国首尔市南山公园森林附近，和庆尚北道庆州市，于1906年创建，1946年升格为大学。目前为韩国最强的影像艺术大学。2023年，东国大学仅首尔单校区就在QS世界大学排名排行全球第481名亚洲第74名，在AWRU专业排名中也有部分理工专业来到世界百强。",
    "end_date": "已截止",
    "Dormitory": "莲花洞双人间：5400                莲花洞三人间：4300",
    "B_Fee": "语言课程16800",
    "B_Fee_2": "",
    "end": "T"
  },
  {
    "id": "A3",
    "name": "清州大学",
    "info": "清州大学前身为1924年创办的大成普通学校。韩国光复之后，清州大学是政府新批准设立的第一所四年制大学，时名“清州商科大学”，1946年11月18日取得设立认可，1947年6月6日开校，1951年更名为“清州大学”。",
    "end_date": "已截止",
    "Dormitory": "牛岩村双人间：4200                     礼智馆双人间：4600              国际宿舍四人间：3400",
    "B_Fee": "语言课程3000",
    "B_Fee_2": "",
    "end": "T"
  },
  {
    "id": "A4",
    "name": "庆云大学",
    "info": "庆云大学是韩国一所成立于1997年的四年制私立大学，主校区位于庆尚北道龟尾市，另设大邱校区。该校以工学、医疗保健学科为特色，设有航空工科学院、航空服务学院、医疗保健学院、社会安全学院等4个二级学院，在校生规模近1万名。",
    "end_date": "第三批次：5月26日-6月5日 第四批次：6月23日-7月04日 第五批次：7月21日-8月1日",
    "Dormitory": "双人间：4000（公浴）",
    "B_Fee": "语言课程6100",
    "B_Fee_2": "翻译费6100",
    "end": ""
  },
  {
    "id": "A5",
    "name": "江南大学",
    "info": "江南大学最初创立于1946年，一直以来，秉承\"敬天爱人\"的教学宗旨，不断发展壮大。 1976年更名为\"江南社会福利学校\"，1989年发展为\"江南学院\"，1992年正式成为全日制综合大学。江南大学是教育部认证的优秀高校，首尔圈位于京畿道，地铁直达首尔城区，生活成本还比首尔低，不收语言费用。毕业要求TOPIK1级。",
    "end_date": "7月9日截止",
    "Dormitory": "心田1馆四人间：3700\r\n心田2馆双人间：6800",
    "B_Fee": "",
    "B_Fee_2": "",
    "end": ""
  },
  {
    "id": "A6",
    "name": "大真大学",
    "info": "大真大学坐落于韩国首都首尔附近的京畿道抱川市，该大学于1984年开始筹建，于1992年正式成立，是韩国京畿道北部的重点大学。中文授课部分采用AI翻译辅助授课。",
    "end_date": "已截止",
    "Dormitory": "7栋/1栋双人间：6600（餐75：1900）\r\n6栋双人间：5500（餐751900）",
    "B_Fee": "语言课程10000",
    "B_Fee_2": "",
    "end": "T"
  },
  {
    "id": "A7",
    "name": "亚洲大学",
    "info": "亚洲大学位于韩国京畿道水原市，是一所成立于1973年的综合性私立研究型大学，由韩国与法国政府合作创立。作为韩国的重点大学，亚洲大学是韩国顶尖学府之一，享有极高的学术声誉。在2024年中央日报社发布的韩国大学排名中，亚洲大学位列第12位。在国际排名方面，亚洲大学在2023年QS世界大学排名中位列488位，且在2024年QS亚洲大学排名中，位列亚洲第134位。",
    "end_date": "已截止",
    "Dormitory": "国际宿舍双人间：8300\r\n花红馆双人间：6400 \r\n花红馆四人间：4300",
    "B_Fee": "",
    "B_Fee_2": "",
    "end": "T"
  },
  {
    "id": "A8",
    "name": "信韩大学",
    "info": "信韩大学是位于韩国首都圈京畿道的知名综合研究型大学。为韩国基督教会附属大学成员。信韩大学于2014年3月由信兴大学及韩北大学合并诞生。其历史可以追溯至1960年1月创办的信兴学院。其坐落于韩国京畿道北部核心的地理位置，坐拥议政府校区及东豆川校区，属首尔圈校区。距离首尔坐地铁30分钟，住宿在东豆川校区，上课在议政府需要来回跑。",
    "end_date": "6月17日-7月4日",
    "Dormitory": "卡梅罗3号宿舍（东豆川校区）三人间：3100（独浴）",
    "B_Fee": "PAYTHWAY PROGAM课程13500",
    "B_Fee_2": "",
    "end": ""
  },
  {
    "id": "A9",
    "name": "大邱加图立大学",
    "info": "大邱加图立大学，位于韩国东南部庆尚北道庆山市，创建于1914年，是一所历史悠久，学习氛围浓厚的百年综合类大学，也是岭南地区第一所大学，校园依山而建，环境优美，单晓星主校区占地面积达到120万平方米以上。学校以\"爱心·奉献\"为校训，以培养德才兼备的人才为教育基础，现拥有在校生约1.8万名，其中硕士生、博士生比例约占学校总人数的10.8%，海外留学生比例约占2%。",
    "end_date": "7月4日截止",
    "Dormitory": "校外宿舍单人间：2万9/年\r\n校外宿舍双人间：1万5/年\r\n校内宿舍双人间：8800/年\r\n校内宿舍四人间：5700/年",
    "B_Fee": "学杂费16800",
    "B_Fee_2": "",
    "end": ""
  },
  {
    "id": "A10",
    "name": "圣公会大学",
    "info": "圣公会大学创建于1914年，以神学院建校，位于韩国首都首尔是韩国的一所私立4年制大学，1989年更名为圣公会神学校，1992年再次更名为圣公会专科大学，1994年升级为综合性大学并正式更名圣公会大学。",
    "end_date": "已截止",
    "Dormitory": "幸福宿舍双人间：4484（独浴）\r\n米迦勒宿舍双人间：4484（独浴）",
    "B_Fee": "韩语课程9939",
    "B_Fee_2": "假期课程2397",
    "end": "T"
  },
  {
    "id": "A11",
    "name": "明知大学",
    "info": "明知大学，创建于1948年，是一所综合性私立大学，位于首尔市内的校区设有人文社会学科单科学院，位于离首尔一个小时距离的龙仁校区设有自然科学学科及艺术体育单科学院，明知大学还设有面向外国留学生的韩国语教育机构，即韩国语学堂。长期以来，明知大学的毕业生活跃在韩国各行各业，发挥其重要作用。据2021CWUR世界大学排名，该校位列韩国第46位，世界第1445位。",
    "end_date": "已截止",
    "Dormitory": "人文生活馆四人间：6000\r\n自然生活馆四人间：6000（含50张餐券",
    "B_Fee": "",
    "B_Fee_2": "",
    "end": "T"
  },
  {
    "id": "A12",
    "name": "灵山大学",
    "info": "灵山大学作为一所年轻的4年制综合性大学拥有9大院系41个学科和1个基础学部，现有在校学生13,000余名，灵山大学拥有两个校区，分别坐落在韩国旅游名城釜山海云台区和工业城市带中心的梁山市。",
    "end_date": "7月20日截止",
    "Dormitory": "梁山单人间：5500\r\n梁山双人间：4800\r\n梁山三人间（1）：4400\r\n梁山三人间（2）：4200\r\n梁山四人间：2700\r\n釜山K栋双人间：5000\r\n釜山H栋双人间：4800\r\n釜山H栋四人间（大）：3000\r\n釜山H栋四人间（中）：2700",
    "B_Fee": "",
    "B_Fee_2": "",
    "end": ""
  },
  {
    "id": "A13",
    "name": "秋溪艺术大学",
    "info": "秋溪艺术大学是韩国的一所私立艺术本科大学，1974年成立两年制专科学校，1976年开设四年制课程，1997年升格为大学。在韩国艺术类大学中排名较高，通常被认为是韩国艺术类院校的第二名。在音乐和美术领域享有盛誉，并以其在艺术实践和学术上的卓越水平而闻名。也是韩国唯一一所提供博士学位课程的专业艺术大学。﻿",
    "end_date": "7月22日截止",
    "Dormitory": "单人间：5156\r\n双人间：5156  \r\n四人间：3898",
    "B_Fee": "韩语课程8600",
    "B_Fee_2": "",
    "end": ""
  },
  {
    "id": "A14",
    "name": "启明大学",
    "info": "前身可追溯到1899年创立的济众院，后与1978年升格为启明大学校。坐落于韩国第三大城市——大邱市，是韩国一所综合性私立大学。亚洲大学排名200强之一。",
    "end_date": "6月23日-7月4日",
    "Dormitory": "一般楼两人间：3400\r\n国际楼奉献栋（男，两人间）：6600\r\n国际楼协力栋（女，两人间）：6600\r\n国际楼新建栋两人间：7000",
    "B_Fee": "",
    "B_Fee_2": "",
    "end": ""
  },
  {
    "id": "A15",
    "name": "世明大学",
    "info": "世明大学创立于1991年，是位于韩国忠清北道的一所私立综合性大学。学校是韩国教育部“教育国际化能力认证大学”、“产学合作领先大学（LINC+）”。",
    "end_date": "7月17日截止",
    "Dormitory": "双人间：3900 餐费：27/餐",
    "B_Fee": "韩语课程6600",
    "B_Fee_2": "",
    "end": ""
  },
  {
    "id": "A16",
    "name": "建国大学",
    "info": "建国大学分别在首尔与忠州各有校区，首尔校区位于韩国首都首尔市广津区华阳洞。在优势学科方面，建国大学是韩国兽医学科最强的大学。并且基因工程学科、经济学科也较为著名。曾于2004年获商学院经济学科领域评价之研究领域韩国第一名。2025年，该校在QS世界大学排名中，位列第721-730名区间；在QS亚洲大学排名中，位列第140名。稳居韩国高校前列。",
    "end_date": "已截止",
    "Dormitory": "Mosirae三人间：9000（含餐费）\r\nMosirae四人间：7900（含餐费）\r\nHaeoreum双人间：9300（含部分餐费）\r\nHaeoreum三人间：8200（含部分餐费）",
    "B_Fee": "韩语课程10600",
    "B_Fee_2": "",
    "end": "T"
  },
  {
    "id": "A17",
    "name": "江原大学",
    "info": "江原大学，是韩国中央政府直属的十所国立旗帜大学之一。 江原大学在韩国享有“关东地区最高综合学府的美誉”，现已发展成为韩国东部地区规模最大、实力最为雄厚的国立综合性重点大学。2010年，江原大学在QS世界大学排名亚洲排第171。课堂配了AI翻译设备。",
    "end_date": "已截止",
    "Dormitory": "礼智馆双人间：5400\r\n",
    "B_Fee": "语言课程19800",
    "B_Fee_2": "",
    "end": "T"
  },
  {
    "id": "A18",
    "name": "京福大学",
    "info": "京福大学，是一所为培养满足先进技术和现代化工业需求人才而设的应用型大学。 学校建立于1991年，以培养专业性的技术人才为目的，于2017年、2018年和2019年在韩国全国应用型大学和4年制大学整合统计中就业率第一。",
    "end_date": "7月15截止",
    "Dormitory": "双人间：17000/年",
    "B_Fee": "韩语课程7900",
    "B_Fee_2": "翻译费6900",
    "end": ""
  },
  {
    "id": "A19",
    "name": "又石大学",
    "info": "又石大学位于韩国最富盛名的历史文化名城全州市。学校拥有悠久的校史和雄厚的底蕴, 现已发展成为大韩民国最具代表性的名牌大学之一。在韩国教育部主持的评估中, 被评为最高等级的A级大学。",
    "end_date": "二批 5月19日-5月30日  三批 6月19日-7月10日",
    "Dormitory": "全州双人间：4100\r\n全州三人间：3800\r\n银川双人间：5000",
    "B_Fee": "韩语课程15500",
    "B_Fee_2": "翻译费3400",
    "end": ""
  },
  {
    "id": "A20",
    "name": "釜山外国语大学",
    "info": "釜山外国语大学是大韩民国两所4年制外国语大学的其中一所，是以外国语和MBA商学院为重点的综合大学，也是一所国策型综合大学。釜山外国语大学为2002年度韩国教育改革最优秀大学。",
    "end_date": "已截止",
    "Dormitory": "校内双人间：4100\r\n校外双人间：9400\r\n校外三人间：6200",
    "B_Fee": "餐费20-30/顿",
    "B_Fee_2": "",
    "end": "T"
  },
  {
    "id": "A21",
    "name": "全州大学",
    "info": "全州大学成立于1964年1月9日，是一所韩国的四年制综合类大学，1984年12月新东亚集团接管后逐渐成长为全州地区综合大学；是全国194所大学中排名中位左右的大学。",
    "end_date": "已截止",
    "Dormitory": "Star Vil两人间：4600\r\nStar Tower两人间：6600",
    "B_Fee": "韩语课程4100",
    "B_Fee_2": "",
    "end": "T"
  },
  {
    "id": "A22",
    "name": "白石大学",
    "info": "白石大学是韩国著名的私立研究型综合大学。白石大学入学竞争极为激烈，入学竞争力平均为20比1。白石大学在韩国，乃至国际上口碑与声望极高。2018年白石大学被评为非首都地区就业率第1位，现已与世界100强企业广泛开展产学合作， 2016年获评国际化力量认证大学。",
    "end_date": "7月18日截止",
    "Dormitory": "三人间：7000\r\n四人间：3000",
    "B_Fee": "韩语课程6600",
    "B_Fee_2": "",
    "end": ""
  },
  {
    "id": "A23",
    "name": "忠北保健科学大学",
    "info": "韩国忠北保健科学大学位于大韩民国忠清北道清州市，已经培养了36000名校友，并和社会一同进步，成为了一个真正的高等职业技术教育机构。护理类专业不要求护理资格证即可申请。",
    "end_date": "7月25日截止",
    "Dormitory": "双人间：3895\r\n三人间：2579",
    "B_Fee": "翻译费9474",
    "B_Fee_2": "韩语课程费8421",
    "end": ""
  },
  {
    "id": "A24",
    "name": "大邱韩医大学",
    "info": "位于韩国庆尚北道庆山市的私立大学，以韩医教育和研究为主，也是韩国著名的综合性大学。 该校建立于1980年，设有韩医学院、韩医药生产学院等，注重培养韩医领域的专业人才。 医学类专业排韩国前十。",
    "end_date": "已截止",
    "Dormitory": "双人间：5000",
    "B_Fee": "韩语课程7500",
    "B_Fee_2": "翻译费6000",
    "end": ""
  },
  {
    "id": "A25",
    "name": "乙支大学",
    "info": "乙支大学是新近成立的私立大学。2006年12月，原来的乙支医科大学及首尔保健大学合并，并改名为“乙支大学”。是韩国唯一的保健医疗特性化的私立大学。",
    "end_date": "6月18日-7月2日",
    "Dormitory": "双人间：6900",
    "B_Fee": "韩语课程6000",
    "B_Fee_2": "",
    "end": "T"
  },
  {
    "id": "A26",
    "name": "东明大学",
    "info": "东明大学始建于1977年，坐落韩国第二大城市釜山。是一所极具国际化、综合性丰富的高等学府。东明大学已获得中国教育部授予的学士及学士以上学位认证和韩国教育部与韩国法务部授予的国际教育质量保证体系（IEQAS）认证。并连续五年被评为教育改革优秀大学。",
    "end_date": "7月中旬截止",
    "Dormitory": "双人间：5000（含餐费）",
    "B_Fee": "",
    "B_Fee_2": "",
    "end": ""
  },
  {
    "id": "A27",
    "name": "东新大学",
    "info": "东新大学是韩国的私立综合大学，校训是“勤勉，谦逊，创意”。1987年3月建校。信息通信和土木工程领域的最佳大学（韩国工程教育认证委员会，2022）优秀就业大学（就业劳动部，2020，连续6年，最高等级）",
    "end_date": "7月7日截止",
    "Dormitory": "双人间：3300",
    "B_Fee": "韩语课程4000",
    "B_Fee_2": "",
    "end": ""
  },
  {
    "id": "A28",
    "name": "又松大学",
    "info": "又松大学坐落于汉江以南韩国第二大行政首都、素有韩国硅谷之称的大田广域市。始建于1954年的又松学院，是韩国中部地区规模最大、最具影响力的教育学院。",
    "end_date": "二批6月2日-6月13日 三批6月30日-7月11日",
    "Dormitory": "双人间：4000元",
    "B_Fee": "韩语课程6500",
    "B_Fee_2": "学杂费13800",
    "end": ""
  },
  {
    "id": "A29",
    "name": "牧园大学",
    "info": "牧园大学成立于1954年5月，位于韩国六个直辖市之一的大田广域市，现已拥有超过44万5050平方米的宽阔校园。牧园大学立足于基督教精神，以实现真理、博爱、奉献的建学理念为教育目标，是韩国中部地区著名的综合性私立大学。",
    "end_date": "已截止",
    "Dormitory": "四人间：3000\r\n双人间：4200",
    "B_Fee": "韩语课程7500",
    "B_Fee_2": "报名费5000",
    "end": "T"
  },
  {
    "id": "A30",
    "name": "庆一大学",
    "info": "庆一大学是韩国的一所私立综合大学,成立于1963年。在2001年公布的全国大学综合评价中，庆一大学以最高分被评为全国最优秀大学。",
    "end_date": "",
    "Dormitory": "雄飞馆三人间：6316\r\n木莲馆单人间：18947\r\n木莲馆双人间：9474\r\n木莲馆三人间：7895",
    "B_Fee": "韩国语言费7000/学期",
    "B_Fee_2": "翻译费2200/学期",
    "end": ""
  },
  {
    "id": "A31",
    "name": "圣洁大学",
    "info": "圣洁大学建于1962年,位于韩国首尔经济圈的核心区域,地理条件优越,距离青瓦台约 25公里,距首尔站约24公里,与仁川国际机场相距55公里,金浦国际机场24公里。",
    "end_date": "已截止",
    "Dormitory": "双人间：5000                     三人间：4800                     四人间：4600   ",
    "B_Fee": "韩语课程5000",
    "B_Fee_2": "",
    "end": "T"
  },
  {
    "id": "A32",
    "name": "中部大学",
    "info": "中部大学，是韩国4年制私立大学，建立于1984年2月，是现代化大学，设有忠清南道锦山郡忠清校区及京畿道高阳校区。2016年被选定为特性化大学以及优秀大学。",
    "end_date": "3月10日-6月20日",
    "Dormitory": "校外生活馆双人间：1.5万/年",
    "B_Fee": "300课时韩语课程11600",
    "B_Fee_2": "",
    "end": ""
  },
  {
    "id": "A33",
    "name": "尚志大学",
    "info": "尚志大学创建于1955年，位于韩国江源道原州市，是所韩国私立综合大学，1974年法人青岩学院改名为尚志学院，校名也更改为尚志大学，1989年升级为综合大学。",
    "end_date": "随时可申",
    "Dormitory": "双人间：4800",
    "B_Fee": "学杂费29800",
    "B_Fee_2": "",
    "end": ""
  },
  {
    "id": "A34",
    "name": "三育大学",
    "info": "三育大学是位于韩国首尔的百年名校，于1906年建校，现在校生七千余名，以培养\"真理和爱心奉献者\"的人才教育理念下，三首大学将知性、灵性和健康融会贯通，小则创造个人幸福大则造福人类社会，并愿把这深远的意义承续下去，三青大学一直在培养具有正确人生价值观\r\n的创造型人才。另外，三青大学是得到包括韩国教育部在内，世界各国认证的正规大学。目前已同全球200多个大学建立了姊妹关系，并共同进行多种国际项目。",
    "end_date": "二批：06.3-06.18 三批 07.02-07.16",
    "Dormitory": "单人间：11465/学期 双人间：6340元/学期 三人间/4325元/学期",
    "B_Fee": "",
    "B_Fee_2": "",
    "end": ""
  },
  {
    "id": "A35",
    "name": "京东大学",
    "info": "·",
    "end_date": "可申请",
    "Dormitory": "",
    "B_Fee": "",
    "B_Fee_2": "",
    "end": ""
  },
  {
    "name": "昌信大学",
    "info": "",
    "end_date": "7月16日截止",
    "Dormitory": "双人间：3900一学期",
    "B_Fee": "翻译费6500",
    "B_Fee_2": "语言课程6500",
    "end": ""
  }
];
export const bItems = [
  {
    "id": "B1",
    "name": "经营·管理",
    "info": "管理学士",
    "connections": [
      {
        "a": "A1",
        "c": "C1",
        "key": ""
      },
      {
        "a": "A2",
        "c": "C15",
        "key": ""
      },
      {
        "a": "A2",
        "c": "C22",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C26",
        "key": ""
      },
      {
        "a": "A5",
        "c": "C63",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C98",
        "key": ""
      },
      {
        "a": "A14",
        "c": "C151",
        "key": ""
      },
      {
        "a": "A15",
        "c": "C157",
        "key": ""
      },
      {
        "a": "A19",
        "c": "C178",
        "key": ""
      },
      {
        "a": "A20",
        "c": "C188",
        "key": ""
      },
      {
        "a": "A21",
        "c": "C191",
        "key": ""
      },
      {
        "a": "A22",
        "c": "C199",
        "key": ""
      },
      {
        "a": "A23",
        "c": "C206",
        "key": ""
      },
      {
        "a": "A26",
        "c": "C232",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C246",
        "key": ""
      },
      {
        "a": "A28",
        "c": "C251",
        "key": ""
      },
      {
        "a": "A29",
        "c": "C261",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C265",
        "key": ""
      },
      {
        "a": "A32",
        "c": "C291",
        "key": ""
      },
    ]
  },
  {
    "id": "B2",
    "name": "酒店管理",
    "info": "工商管理（酒店旅游管理）学士",
    "connections": [
      {
        "a": "A3",
        "c": "C29",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C134",
        "key": ""
      },
      {
        "a": "A28",
        "c": "C252",
        "key": ""
      }
    ]
  },
  {
    "id": "B3",
    "name": "会计",
    "info": "工商管理学学士，专业领域：会计/大邱是会计学学士",
    "connections": [
      {
        "a": "A1",
        "c": "C2",
        "key": ""
      },
      {
        "a": "A2",
        "c": "C21",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C27",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C97",
        "key": ""
      },
      {
        "a": "A20",
        "c": "C189",
        "key": ""
      }
    ]
  },
  {
    "id": "B4",
    "name": "国际贸易",
    "info": "经济金融学学士",
    "connections": [
      {
        "a": "A1",
        "c": "C3",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C86",
        "key": ""
      },
      {
        "a": "A11",
        "c": "C132",
        "key": ""
      }
    ]
  },
  {
    "id": "B5",
    "name": "艺术设计",
    "info": "设计学学士",
    "connections": [
      {
        "a": "A2",
        "c": "C16",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C38",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C39",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C40",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C41",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C42",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C43",
        "key": ""
      },
      {
        "a": "A4",
        "c": "C62",
        "key": ""
      },
      {
        "a": "A5",
        "c": "C66",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C87",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C126",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C127",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C128",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C129",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C137",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C138",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C139",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C140",
        "key": ""
      },
      {
        "a": "A15",
        "c": "C161",
        "key": ""
      },
      {
        "a": "A18",
        "c": "C177",
        "key": ""
      },
      {
        "a": "A19",
        "c": "C187",
        "key": ""
      },
      {
        "a": "A24",
        "c": "C211",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C225",
        "key": ""
      },
      {
        "a": "A26",
        "c": "C235",
        "key": ""
      },
      {
        "a": "A26",
        "c": "C236",
        "key": ""
      },
      {
        "a": "A28",
        "c": "C258",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C267",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C282",
        "key": ""
      },
      {
        "a": "A17",
        "c": "C296",
        "key": ""
      },
      {
        "a": "A26",
        "c": "C297",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C299",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C301",
        "key": ""
      },
      {
        "a": "A14",
        "c": "C330",
        "key": ""
      },
      {
        "a": "A14",
        "c": "C331",
        "key": ""
      },
      {
        "a": "A14",
        "c": "C332",
        "key": ""
      }
    ]
  },
  {
    "id": "B6",
    "name": "多媒体",
    "info": "",
    "connections": [
      {
        "a": "A11",
        "c": "C133",
        "key": ""
      },
      {
        "a": "A28",
        "c": "C254",
        "key": ""
      },
      {
        "a": "A28",
        "c": "C257",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C284",
        "key": ""
      }
    ]
  },
  {
    "id": "B7",
    "name": "计算机",
    "info": "工学学士",
    "connections": [
      {
        "a": "A1",
        "c": "C7",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C33",
        "key": ""
      },
      {
        "a": "A7",
        "c": "C77",
        "key": ""
      },
      {
        "a": "A8",
        "c": "C82",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C89",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C112",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C113",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C114",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C115",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C146",
        "key": ""
      },
      {
        "a": "A15",
        "c": "C160",
        "key": ""
      },
      {
        "a": "A17",
        "c": "C162",
        "key": ""
      },
      {
        "a": "A18",
        "c": "C175",
        "key": ""
      },
      {
        "a": "A19",
        "c": "C185",
        "key": ""
      },
      {
        "a": "A20",
        "c": "C190",
        "key": ""
      },
      {
        "a": "A21",
        "c": "C192",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C230",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C231",
        "key": ""
      },
      {
        "a": "A26",
        "c": "C233",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C239",
        "key": ""
      },
      {
        "a": "A28",
        "c": "C255",
        "key": ""
      },
      {
        "a": "A29",
        "c": "C262",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C268",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C278",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C279",
        "key": ""
      },
      {
        "a": "A5",
        "c": "C295",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C298",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C300",
        "key": ""
      }
    ]
  },
  {
    "id": "B8",
    "name": "机械工学 ",
    "info": "工学学士",
    "connections": [
      {
        "a": "A1",
        "c": "C9",
        "key": ""
      },
      {
        "a": "A8",
        "c": "C83",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C108",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C142",
        "key": ""
      },
      {
        "a": "A14",
        "c": "C155",
        "key": ""
      },
      {
        "a": "A21",
        "c": "C194",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C240",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C269",
        "key": ""
      },
      {
        "a": "A14",
        "c": "C329",
        "key": ""
      }
    ]
  },
  {
    "id": "B9",
    "name": "电气·电子·信息",
    "info": "电子·信息通信工学 工学学士",
    "connections": [
      {
        "a": "A1",
        "c": "C11",
        "key": ""
      },
      {
        "a": "A2",
        "c": "C18",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C36",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C37",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C107",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C110",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C143",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C144",
        "key": ""
      },
      {
        "a": "A14",
        "c": "C154",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C280",
        "key": ""
      },
      {
        "a": "A14",
        "c": "C328",
        "key": ""
      }
    ]
  },
  {
    "id": "B10",
    "name": "生物制药",
    "info": "生物制药工学",
    "connections": [
      {
        "a": "A2",
        "c": "C17",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C44",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C101",
        "key": ""
      },
      {
        "a": "A24",
        "c": "C209",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C270",
        "key": ""
      }
    ]
  },
  {
    "id": "B11",
    "name": "护理学",
    "info": "包含护理学等",
    "connections": [
      {
        "a": "A4",
        "c": "C45",
        "key": ""
      },
      {
        "a": "A23",
        "c": "C201",
        "key": ""
      },
      {
        "a": "A24",
        "c": "C207",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C315",
        "key": ""
      }
    ]
  },
  {
    "id": "B12",
    "name": "保健康复",
    "info": "包含保健康复等",
    "connections": [
      {
        "a": "A4",
        "c": "C46",
        "key": ""
      },
      {
        "a": "A4",
        "c": "C47",
        "key": ""
      },
      {
        "a": "A4",
        "c": "C48",
        "key": ""
      },
      {
        "a": "A4",
        "c": "C49",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C88",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C102",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C103",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C104",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C147",
        "key": ""
      },
      {
        "a": "A17",
        "c": "C168",
        "key": ""
      },
      {
        "a": "A17",
        "c": "C169",
        "key": ""
      },
      {
        "a": "A19",
        "c": "C183",
        "key": ""
      },
      {
        "a": "A23",
        "c": "C202",
        "key": ""
      },
      {
        "a": "A23",
        "c": "C204",
        "key": ""
      },
      {
        "a": "A23",
        "c": "C205",
        "key": ""
      },
      {
        "a": "A24",
        "c": "C208",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C212",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C213",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C214",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C215",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C216",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C217",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C220",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C221",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C228",
        "key": ""
      },
      {
        "a": "A26",
        "c": "C234",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C241",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C243",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C308",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C312",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C316",
        "key": ""
      }
    ]
  },
  {
    "id": "B13",
    "name": "医疗经营",
    "info": "工商管理学士·医疗服务管理",
    "connections": [
      {
        "a": "A4",
        "c": "C50",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C106",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C224",
        "key": ""
      }
    ]
  },
  {
    "id": "B14",
    "name": "航空经营",
    "info": "工商管理（航空经营）",
    "connections": [
      {
        "a": "A4",
        "c": "C51",
        "key": ""
      },
      {
        "a": "A4",
        "c": "C52",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C95",
        "key": ""
      }
    ]
  },
  {
    "id": "B15",
    "name": "航空工学",
    "info": "",
    "connections": [
      {
        "a": "A4",
        "c": "C53",
        "key": ""
      },
      {
        "a": "A4",
        "c": "C54",
        "key": ""
      },
      {
        "a": "A4",
        "c": "C55",
        "key": ""
      },
      {
        "a": "A4",
        "c": "C56",
        "key": ""
      },
      {
        "a": "A4",
        "c": "C57",
        "key": ""
      },
      {
        "a": "A4",
        "c": "C58",
        "key": ""
      }
    ]
  },
  {
    "id": "B16",
    "name": "新闻广播",
    "info": "新闻学学士",
    "connections": [
      {
        "a": "A3",
        "c": "C30",
        "key": ""
      }
    ]
  },
  {
    "id": "B17",
    "name": "建筑工学",
    "info": "工学学士",
    "connections": [
      {
        "a": "A1",
        "c": "C8",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C34",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C35",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C111",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C145",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C238",
        "key": ""
      },
      {
        "a": "A28",
        "c": "C253",
        "key": ""
      }
    ]
  },
  {
    "id": "B18",
    "name": "国际地域",
    "info": "国际区域学学士",
    "connections": [
      {
        "a": "A9",
        "c": "C92",
        "key": ""
      }
    ]
  },
  {
    "id": "B19",
    "name": "国际语言",
    "info": "文学学士（汉语言）",
    "connections": [
      {
        "a": "A1",
        "c": "C13",
        "key": ""
      },
      {
        "a": "A2",
        "c": "C14",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C32",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C93",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C94",
        "key": ""
      },
      {
        "a": "A14",
        "c": "C152",
        "key": ""
      },
      {
        "a": "A17",
        "c": "C166",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C264",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C271",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C272",
        "key": ""
      },
      {
        "a": "A14",
        "c": "C335",
        "key": ""
      }
    ]
  },
  {
    "id": "B20",
    "name": "媒体传播",
    "info": "新闻学学士",
    "connections": [
      {
        "a": "A9",
        "c": "C120",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C121",
        "key": ""
      },
      {
        "a": "A26",
        "c": "C237",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C303",
        "key": ""
      }
    ]
  },
  {
    "id": "B21",
    "name": "音乐学",
    "info": "音乐学学士（实用音乐）",
    "connections": [
      {
        "a": "A5",
        "c": "C67",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C125",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C141",
        "key": ""
      },
      {
        "a": "A13",
        "c": "C149",
        "key": ""
      },
      {
        "a": "A18",
        "c": "C176",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C249",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C281",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C283",
        "key": ""
      },
      {
        "a": "A14",
        "c": "C334",
        "key": ""
      }
    ]
  },
  {
    "id": "B22",
    "name": "美术",
    "info": "美术学",
    "connections": [
      {
        "a": "A13",
        "c": "C148",
        "key": ""
      }
    ]
  },
  {
    "id": "B23",
    "name": "舞蹈",
    "info": "舞蹈学",
    "connections": [
      {
        "a": "A13",
        "c": "C150",
        "key": ""
      },
      {
        "a": "A14",
        "c": "C153",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C250",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C302",
        "key": ""
      }
    ]
  },
  {
    "id": "B24",
    "name": "法学",
    "info": "法学学士",
    "connections": [
      {
        "a": "A1",
        "c": "C4",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C31",
        "key": ""
      },
      {
        "a": "A15",
        "c": "C158",
        "key": ""
      }
    ]
  },
  {
    "id": "B25",
    "name": "食品营养",
    "info": "理学学士 世明 工学",
    "connections": [
      {
        "a": "A9",
        "c": "C99",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C100",
        "key": ""
      },
      {
        "a": "A15",
        "c": "C159",
        "key": ""
      },
      {
        "a": "A17",
        "c": "C170",
        "key": ""
      },
      {
        "a": "A24",
        "c": "C210",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C218",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C219",
        "key": ""
      }
    ]
  },
  {
    "id": "B26",
    "name": "物流经营",
    "info": "",
    "connections": [
      {
        "a": "A12",
        "c": "C136",
        "key": ""
      }
    ]
  },
  {
    "id": "B27",
    "name": "观光会展学",
    "info": "",
    "connections": [
      {
        "a": "A12",
        "c": "C135",
        "key": ""
      }
    ]
  },
  {
    "id": "B28",
    "name": "美妆时尚造型",
    "info": "艺术学学士",
    "connections": [
      {
        "a": "A8",
        "c": "C84",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C244",
        "key": ""
      }
    ]
  },
  {
    "id": "B29",
    "name": "运动体育健康",
    "info": "体育学士",
    "connections": [
      {
        "a": "A2",
        "c": "C19",
        "key": ""
      },
      {
        "a": "A2",
        "c": "C20",
        "key": ""
      },
      {
        "a": "A2",
        "c": "C23",
        "key": ""
      },
      {
        "a": "A4",
        "c": "C61",
        "key": ""
      },
      {
        "a": "A8",
        "c": "C85",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C105",
        "key": ""
      },
      {
        "a": "A17",
        "c": "C167",
        "key": ""
      },
      {
        "a": "A19",
        "c": "C186",
        "key": ""
      },
      {
        "a": "A23",
        "c": "C203",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C223",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C247",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C248",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C317",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C318",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C319",
        "key": ""
      }
    ]
  },
  {
    "id": "B30",
    "name": "保安警护学",
    "info": "",
    "connections": [
      {
        "a": "A4",
        "c": "C60",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C320",
        "key": ""
      }
    ]
  },
  {
    "id": "B31",
    "name": "公共行政",
    "info": "管理学士（公共行政）",
    "connections": [
      {
        "a": "A17",
        "c": "C163",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C275",
        "key": ""
      }
    ]
  },
  {
    "id": "B32",
    "name": "园林设计",
    "info": "工学学士",
    "connections": [
      {
        "a": "A1",
        "c": "C10",
        "key": ""
      },
      {
        "a": "A19",
        "c": "C182",
        "key": ""
      }
    ]
  },
  {
    "id": "B33",
    "name": "园林学",
    "info": "理学学士",
    "connections": [
      {
        "a": "A1",
        "c": "C12",
        "key": ""
      }
    ]
  },
  {
    "id": "B34",
    "name": "旅游学",
    "info": "旅游学学士",
    "connections": [
      {
        "a": "A1",
        "c": "C5",
        "key": ""
      },
      {
        "a": "A1",
        "c": "C6",
        "key": ""
      },
      {
        "a": "A19",
        "c": "C184",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C273",
        "key": ""
      },
    ]
  },
  {
    "id": "B35",
    "name": "医疗保健护理",
    "info": "保健学学士",
    "connections": [
      {
        "a": "A2",
        "c": "C25",
        "key": ""
      },
      {
        "a": "A8",
        "c": "C81",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C90",
        "key": ""
      },
      {
        "a": "A18",
        "c": "C174",
        "key": ""
      }
    ]
  },
  {
    "id": "B36",
    "name": "幼儿教育",
    "info": "教育学",
    "connections": [
      {
        "a": "A8",
        "c": "C78",
        "key": ""
      },
      {
        "a": "A17",
        "c": "C165",
        "key": ""
      },
      {
        "a": "A18",
        "c": "C173",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C288",
        "key": ""
      },
    ]
  },
  {
    "id": "B37",
    "name": "国际经营",
    "info": "经营学",
    "connections": [
      {
        "a": "A6",
        "c": "C70",
        "key": ""
      },
      {
        "a": "A8",
        "c": "C79",
        "key": ""
      },
      {
        "a": "A16",
        "c": "C171",
        "key": ""
      },
      {
        "a": "A22",
        "c": "C197",
        "key": ""
      },
      {
        "a": "A29",
        "c": "C259",
        "key": ""
      },
      {
        "a": "A5",
        "c": "C294",
        "key": ""
      }
    ]
  },
  {
    "id": "B38",
    "name": "汽车机械",
    "info": "工学学士",
    "connections": []
  },
  {
    "id": "B39",
    "name": "媒体传播",
    "info": "媒体学",
    "connections": [
      {
        "a": "A8",
        "c": "C80",
        "key": ""
      },
      {
        "a": "A16",
        "c": "C172",
        "key": ""
      },
      {
        "a": "A19",
        "c": "C181",
        "key": ""
      }
    ]
  },
  {
    "id": "B40",
    "name": "人工智能",
    "info": "理学",
    "connections": []
  },
  {
    "id": "B41",
    "name": "儿童教育",
    "info": "理学",
    "connections": [
      {
        "a": "A9",
        "c": "C118",
        "key": ""
      },
      {
        "a": "A19",
        "c": "C179",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C226",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C227",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C309",
        "key": ""
      },
      {
        "a": "A2",
        "c": "C336",
        "key": ""
      }
    ]
  },
  {
    "id": "B42",
    "name": "教育专业",
    "info": "",
    "connections": [
      {
        "a": "A9",
        "c": "C91",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C124",
        "key": ""
      },
      {
        "a": "A19",
        "c": "C180",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C266",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C287",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C289",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C290",
        "key": ""
      }
    ]
  },
  {
    "id": "B43",
    "name": "医疗工学",
    "info": "",
    "connections": [
      {
        "a": "A14",
        "c": "C156",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C222",
        "key": ""
      }
    ]
  },
  {
    "id": "B44",
    "name": "经济金融",
    "info": "",
    "connections": [
      {
        "a": "A17",
        "c": "C164",
        "key": ""
      }
    ]
  },
  {
    "id": "B45",
    "name": "航空服务",
    "info": "",
    "connections": [
      {
        "a": "A21",
        "c": "C195",
        "key": ""
      },
      {
        "a": "A22",
        "c": "C198",
        "key": ""
      },
      {
        "a": "A29",
        "c": "C260",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C305",
        "key": ""
      }
    ]
  },
  {
    "id": "B46",
    "name": "化妆美容",
    "info": "",
    "connections": [
      {
        "a": "A29",
        "c": "C263",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C310",
        "key": ""
      }
    ]
  },
  {
    "id": "B47",
    "name": "管理专业",
    "info": "",
    "connections": [
      {
        "a": "A31",
        "c": "C274",
        "key": ""
      }
    ]
  },
  {
    "id": "B48",
    "name": "文化艺术·内容",
    "info": "",
    "connections": [
      {
        "a": "A12",
        "c": "C313",
        "key": ""
      },
    ]
  },
  {
    "id": "B49",
    "name": "产品设计",
    "info": "",
    "connections": [
      {
        "a": "A14",
        "c": "C333",
        "key": ""
      }
    ]
  },
  {
    "id": "B99",
    "name": "其他",
    "info": "",
    "connections": [
      {
        "a": "A2",
        "c": "C24",
        "key": ""
      },
      {
        "a": "A3",
        "c": "C28",
        "key": ""
      },
      {
        "a": "A4",
        "c": "C59",
        "key": ""
      },
      {
        "a": "A5",
        "c": "C64",
        "key": ""
      },
      {
        "a": "A5",
        "c": "C65",
        "key": ""
      },

      {
        "a": "A9",
        "c": "C96",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C109",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C116",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C117",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C119",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C122",
        "key": ""
      },
      {
        "a": "A9",
        "c": "C123",
        "key": ""
      },
      {
        "a": "A10",
        "c": "C130",
        "key": ""
      },
      {
        "a": "A10",
        "c": "C131",
        "key": ""
      },
      {
        "a": "A21",
        "c": "C193",
        "key": ""
      },
      {
        "a": "A21",
        "c": "C196",
        "key": ""
      },
      {
        "a": "A22",
        "c": "C200",
        "key": ""
      },
      {
        "a": "A25",
        "c": "C229",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C242",
        "key": ""
      },
      {
        "a": "A27",
        "c": "C245",
        "key": ""
      },
      {
        "a": "A28",
        "c": "C256",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C276",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C277",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C285",
        "key": ""
      },
      {
        "a": "A31",
        "c": "C286",
        "key": ""
      },
      {
        "a": "A4",
        "c": "C292",
        "key": ""
      },
      {
        "a": "A4",
        "c": "C293",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C304",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C306",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C307",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C311",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C314",
        "key": ""
      },
      {
        "a": "A12",
        "c": "C321",
        "key": ""
      },
    ]
  }
];
export const cItems = [
  {
    "id": "C1",
    "name": "经营学",
    "info": "B1_A1",
    "extra_info": "39632元",
    "info2": "工商管理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C2",
    "name": "会计学",
    "info": "B3_A1",
    "extra_info": "39632元",
    "info2": "会计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C3",
    "name": "国际贸易",
    "info": "B4_A1",
    "extra_info": "39632元",
    "info2": "工商管理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C4",
    "name": "法学",
    "info": "B24_A1",
    "extra_info": "39632元",
    "info2": "法学学士",
    "no_prerequisites": false
  },
  {
    "id": "C5",
    "name": "旅游管理",
    "info": "B34_A1",
    "extra_info": "39632元",
    "info2": "旅游学学士",
    "no_prerequisites": false
  },
  {
    "id": "C6",
    "name": "旅游航空经营",
    "info": "B34_A1",
    "extra_info": "39632元",
    "info2": "旅游学学士",
    "no_prerequisites": true
  },
  {
    "id": "C7",
    "name": "网络信息安全",
    "info": "B7_A1",
    "extra_info": "53518元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C8",
    "name": "建筑工学",
    "info": "B17_A1",
    "extra_info": "53518元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C9",
    "name": "机械工学",
    "info": "B8_A1",
    "extra_info": "53518元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C10",
    "name": "园林造景设计",
    "info": "B32_A1",
    "extra_info": "53518元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C11",
    "name": "电气工学",
    "info": "B9_A1",
    "extra_info": "53518元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C12",
    "name": "园林学",
    "info": "B33_A1",
    "extra_info": "50832元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C13",
    "name": "国际语言",
    "info": "B19_A1",
    "extra_info": "39532元",
    "info2": "文学学士",
    "no_prerequisites": true
  },
  {
    "id": "C14",
    "name": "汉语言文学",
    "info": "B19_A2",
    "extra_info": "34550元",
    "info2": "文学学士",
    "no_prerequisites": true
  },
  {
    "id": "C15",
    "name": "经营学",
    "info": "B1_A2",
    "extra_info": "34550元",
    "info2": "工商管理学学士",
    "no_prerequisites": true
  },
  {
    "id": "C16",
    "name": "设计美术",
    "info": "B5_A2",
    "extra_info": "45496元",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C17",
    "name": "*生物制药工学",
    "info": "B10_A2",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C18",
    "name": "*电子·信息通信工学",
    "info": "B9_A2",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C19",
    "name": "*体育科学",
    "info": "B29_A2",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C20",
    "name": "*体育医学",
    "info": "B29_A2",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C21",
    "name": "*会计税务学",
    "info": "B3_A2",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C22",
    "name": "*信息经营学",
    "info": "B1_A2",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C23",
    "name": "*酒店观光经营学",
    "info": "B29_A2",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C24",
    "name": "*料理外食经营学",
    "info": "B99_A2",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C25",
    "name": "*医疗美容学",
    "info": "B35_A2",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C26",
    "name": "经营学",
    "info": "B1_A3",
    "extra_info": "36352元",
    "info2": "工商管理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C27",
    "name": "会计学",
    "info": "B3_A3",
    "extra_info": "36352元",
    "info2": "会计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C28",
    "name": "经济通商",
    "info": "B99_A3",
    "extra_info": "36352元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C29",
    "name": "酒店外食经营",
    "info": "B2_A3",
    "extra_info": "36352元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C30",
    "name": "新闻广播",
    "info": "B16_A3",
    "extra_info": "36352元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C31",
    "name": "法学",
    "info": "B24_A3",
    "extra_info": "36352元",
    "info2": "法学学士",
    "no_prerequisites": false
  },
  {
    "id": "C32",
    "name": "英语英文",
    "info": "B19_A3",
    "extra_info": "36352元",
    "info2": "文学学士",
    "no_prerequisites": false
  },
  {
    "id": "C33",
    "name": "人工智能软件",
    "info": "B7_A3",
    "extra_info": "41493元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C34",
    "name": "城市造景",
    "info": "B17_A3",
    "extra_info": "41493元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C35",
    "name": "建筑工程",
    "info": "B17_A3",
    "extra_info": "41493元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C36",
    "name": "电子工程",
    "info": "B9_A3",
    "extra_info": "41493元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C37",
    "name": "电气控制工程",
    "info": "B9_A3",
    "extra_info": "41493元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C38",
    "name": "视觉设计",
    "info": "B5_A3",
    "extra_info": "45868元",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C39",
    "name": "工艺设计",
    "info": "B5_A3",
    "extra_info": "45868元",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C40",
    "name": "艺术与时尚设计",
    "info": "B5_A3",
    "extra_info": "45868元",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C41",
    "name": "数字媒体设计",
    "info": "B5_A3",
    "extra_info": "45868元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C42",
    "name": "漫画动漫",
    "info": "B5_A3",
    "extra_info": "45868元",
    "info2": "艺术学学士",
    "no_prerequisites": false
  },
  {
    "id": "C43",
    "name": "电影影像",
    "info": "B5_A3",
    "extra_info": "45868元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C44",
    "name": "生物制药医疗学",
    "info": "B10_A3",
    "extra_info": "43555元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C45",
    "name": "护理学",
    "info": "B11_A4",
    "extra_info": "39050元",
    "info2": "护理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C46",
    "name": "物理治疗学",
    "info": "B12_A4",
    "extra_info": "39050元",
    "info2": "保健学士",
    "no_prerequisites": false
  },
  {
    "id": "C47",
    "name": "作业治疗学",
    "info": "B12_A4",
    "extra_info": "39050元",
    "info2": "保健学士",
    "no_prerequisites": false
  },
  {
    "id": "C48",
    "name": "牙齿卫生学",
    "info": "B12_A4",
    "extra_info": "39050元",
    "info2": "牙齿卫生学士",
    "no_prerequisites": false
  },
  {
    "id": "C49",
    "name": "临床病理学",
    "info": "B12_A4",
    "extra_info": "39050元",
    "info2": "理学学士，专业方向为医学检验技术，病理技术，分子检测，助产，卫生检验和检疫。",
    "no_prerequisites": false
  },
  {
    "id": "C50",
    "name": "医疗经营学",
    "info": "B13_A4",
    "extra_info": "30300元",
    "info2": "工商管理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C51",
    "name": "航空交流物流学",
    "info": "B14_A4",
    "extra_info": "39050元",
    "info2": "工商管理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C52",
    "name": "航空观光服务学",
    "info": "B14_A4",
    "extra_info": "30300元",
    "info2": "工商管理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C53",
    "name": "航空机械工学",
    "info": "B15_A4",
    "extra_info": "39800元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C54",
    "name": "航空电子工学",
    "info": "B15_A4",
    "extra_info": "39800元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C55",
    "name": "航空情报工学",
    "info": "B15_A4",
    "extra_info": "39800元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C56",
    "name": "（已删除内容）新素材工学",
    "info": "B100_A100",
    "extra_info": "39800元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C57",
    "name": "航空软件工学",
    "info": "B15_A4",
    "extra_info": "39800元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C58",
    "name": "无人机工学",
    "info": "B15_A4",
    "extra_info": "39800元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C59",
    "name": "安全防灾工学",
    "info": "B99_A4",
    "extra_info": "39800元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C60",
    "name": "（已删除内容）保安警护学",
    "info": "B100_A100",
    "extra_info": "39300元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C61",
    "name": "运动体育健康学",
    "info": "B29_A4",
    "extra_info": "39300元",
    "info2": "体育学学士",
    "no_prerequisites": false
  },
  {
    "id": "C62",
    "name": "多媒体设计动漫学",
    "info": "B5_A4",
    "extra_info": "41800元",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C63",
    "name": "经营学",
    "info": "B1_A5",
    "extra_info": "52400元",
    "info2": "工商管理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C64",
    "name": "社会事业学",
    "info": "B99_A5",
    "extra_info": "52400元",
    "info2": "社会福利学学士",
    "no_prerequisites": false
  },
  {
    "id": "C65",
    "name": "体育福利专业",
    "info": "B99_A5",
    "extra_info": "60600元",
    "info2": "体育学学士",
    "no_prerequisites": false
  },
  {
    "id": "C66",
    "name": "环球艺术设计专业",
    "info": "B5_A5",
    "extra_info": "67000元",
    "info2": "美术设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C67",
    "name": "音乐学专业",
    "info": "B21_A5",
    "extra_info": "67000元",
    "info2": "音乐学学士",
    "no_prerequisites": false
  },
  {
    "id": "C68",
    "name": "儿童学",
    "info": "B41_A6",
    "extra_info": "31500元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C69",
    "name": "国际地域学",
    "info": "B18_A6",
    "extra_info": "41200元",
    "info2": "国际区域学学士",
    "no_prerequisites": false
  },
  {
    "id": "C70",
    "name": "国际经营学",
    "info": "B37_A6",
    "extra_info": "31500元",
    "info2": "工商管理学学士",
    "no_prerequisites": true
  },
  {
    "id": "C71",
    "name": "视觉传达专业",
    "info": "B39_A6",
    "extra_info": "41200元",
    "info2": "",
    "no_prerequisites": true
  },
  {
    "id": "C72",
    "name": "公共人才法学",
    "info": "B24_A6",
    "extra_info": "31500元",
    "info2": "法学学士",
    "no_prerequisites": true
  },
  {
    "id": "C73",
    "name": "智能融合安保",
    "info": "B99_A6",
    "extra_info": "41200元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C74",
    "name": "建筑工程",
    "info": "B17_A6",
    "extra_info": "41200元",
    "info2": "工学学士",
    "no_prerequisites": true
  },
  {
    "id": "C75",
    "name": "电影影视",
    "info": "B6_A6",
    "extra_info": "41200元",
    "info2": "戏剧电影学学士",
    "no_prerequisites": true
  },
  {
    "id": "C76",
    "name": "电气工学",
    "info": "B9_A6",
    "extra_info": "41200元",
    "info2": "工学学士",
    "no_prerequisites": true
  },
  {
    "id": "C77",
    "name": "IT专业",
    "info": "B7_A7",
    "extra_info": "52000元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C78",
    "name": "幼儿融合教育",
    "info": "B36_A8",
    "extra_info": "39400元",
    "info2": "文学学士",
    "no_prerequisites": false
  },
  {
    "id": "C79",
    "name": "国际经营学",
    "info": "B37_A8",
    "extra_info": "39400元",
    "info2": "工商管理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C80",
    "name": "媒体传播学",
    "info": "B39_A8",
    "extra_info": "39400元",
    "info2": "新闻学学士",
    "no_prerequisites": false
  },
  {
    "id": "C81",
    "name": "医疗护理保健",
    "info": "B35_A8",
    "extra_info": "48000元",
    "info2": "保健学学士",
    "no_prerequisites": false
  },
  {
    "id": "C82",
    "name": "软件工程",
    "info": "B7_A8",
    "extra_info": "50000元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C83",
    "name": "机械汽车工学",
    "info": "B8_A8",
    "extra_info": "50000元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C84",
    "name": "美妆时尚造型",
    "info": "B28_A8",
    "extra_info": "50000元",
    "info2": "艺术学学士",
    "no_prerequisites": false
  },
  {
    "id": "C85",
    "name": "体育运动学部",
    "info": "B29_A8",
    "extra_info": "50000元",
    "info2": "体育学学士",
    "no_prerequisites": false
  },
  {
    "id": "C86",
    "name": "全球商务",
    "info": "B4_A9",
    "extra_info": "48000元",
    "info2": "经营，工商管理",
    "no_prerequisites": false
  },
  {
    "id": "C87",
    "name": "媒体设计",
    "info": "B5_A9",
    "extra_info": "48000元",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C88",
    "name": "医疗康复 ",
    "info": "B12_A9",
    "extra_info": "48000元",
    "info2": "物理治疗，康复治疗",
    "no_prerequisites": false
  },
  {
    "id": "C89",
    "name": "人工智能计算机",
    "info": "B7_A9",
    "extra_info": "48000元",
    "info2": "人工智能，Ai大数据",
    "no_prerequisites": false
  },
  {
    "id": "C90",
    "name": "医疗美容管理",
    "info": "B35_A9",
    "extra_info": "48000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C91",
    "name": "国际教育",
    "info": "B42_A9",
    "extra_info": "48000元",
    "info2": "教育学学士",
    "no_prerequisites": false
  },
  {
    "id": "C92",
    "name": "韩国学",
    "info": "B18_A9",
    "extra_info": "48000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C93",
    "name": "英语专业",
    "info": "B19_A9",
    "extra_info": "36000元",
    "info2": "文学学士",
    "no_prerequisites": false
  },
  {
    "id": "C94",
    "name": "日语日文",
    "info": "B19_A9",
    "extra_info": "36000元",
    "info2": "文学学士",
    "no_prerequisites": false
  },
  {
    "id": "C95",
    "name": "全球航空服务",
    "info": "B14_A9",
    "extra_info": "36000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C96",
    "name": "全球文化信息",
    "info": "B99_A9",
    "extra_info": "36000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C97",
    "name": "会计税务",
    "info": "B3_A9",
    "extra_info": "36000元",
    "info2": "会计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C98",
    "name": "经营学",
    "info": "B1_A9",
    "extra_info": "36000元",
    "info2": "工商管理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C99",
    "name": "食品营养专业",
    "info": "B25_A9",
    "extra_info": "50000元",
    "info2": "理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C100",
    "name": "西餐料理烘培",
    "info": "B25_A9",
    "extra_info": "50000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C101",
    "name": "制药工学",
    "info": "B10_A9",
    "extra_info": "50000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C102",
    "name": "语言听觉治疗",
    "info": "B12_A9",
    "extra_info": "50000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C103",
    "name": "放射线",
    "info": "B12_A9",
    "extra_info": "50000元",
    "info2": "理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C104",
    "name": "眼睛光学",
    "info": "B12_A9",
    "extra_info": "50000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C105",
    "name": "生活体育",
    "info": "B29_A9",
    "extra_info": "54000元",
    "info2": "体育学学士",
    "no_prerequisites": false
  },
  {
    "id": "C106",
    "name": "保健医疗经营",
    "info": "B13_A9",
    "extra_info": "36000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C107",
    "name": "半导体电子工程",
    "info": "B9_A9",
    "extra_info": "50000元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C108",
    "name": "机器人工程",
    "info": "B8_A9",
    "extra_info": "50000元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C109",
    "name": "消防防灾专业",
    "info": "B99_A9",
    "extra_info": "50000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C110",
    "name": "电气工程系",
    "info": "B9_A9",
    "extra_info": "50000元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C111",
    "name": "建筑工程",
    "info": "B17_A9",
    "extra_info": "50000元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C112",
    "name": "计算机工学专业",
    "info": "B7_A9",
    "extra_info": "50000元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C113",
    "name": "网络安全专业",
    "info": "B7_A9",
    "extra_info": "50000元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C114",
    "name": "游戏工学专业",
    "info": "B7_A9",
    "extra_info": "50000元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C115",
    "name": "软件融合专业",
    "info": "B7_A9",
    "extra_info": "50000元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C116",
    "name": "文献信息专业",
    "info": "B99_A9",
    "extra_info": "36000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C117",
    "name": "心理专业",
    "info": "B99_A9",
    "extra_info": "36000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C118",
    "name": "儿童专业",
    "info": "B41_A9",
    "extra_info": "36000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C119",
    "name": "社会福祉专业",
    "info": "B99_A9",
    "extra_info": "36000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C120",
    "name": "媒体影响专业",
    "info": "B20_A9",
    "extra_info": "36000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C121",
    "name": "广告宣传专业",
    "info": "B20_A9",
    "extra_info": "36000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C122",
    "name": "警察行政专业",
    "info": "B99_A9",
    "extra_info": "36000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C123",
    "name": "军事学系",
    "info": "B99_A9",
    "extra_info": "36000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C124",
    "name": "教育专业",
    "info": "B42_A9",
    "extra_info": "36000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C125",
    "name": "实用音乐专业",
    "info": "B21_A9",
    "extra_info": "54000元",
    "info2": "音乐学学士",
    "no_prerequisites": false
  },
  {
    "id": "C126",
    "name": "艺术治疗专业",
    "info": "B5_A9",
    "extra_info": "54000元",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C127",
    "name": "产业设计专业",
    "info": "B5_A9",
    "extra_info": "54000元",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C128",
    "name": "时装设计专业",
    "info": "B5_A9",
    "extra_info": "54000元",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C129",
    "name": "金属珠宝设计专业",
    "info": "B5_A9",
    "extra_info": "54000元",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C130",
    "name": "新媒体艺术管理",
    "info": "B99_A10",
    "extra_info": "39640元",
    "info2": "",
    "no_prerequisites": true
  },
  {
    "id": "C131",
    "name": "企业数字化管理",
    "info": "B99_A10",
    "extra_info": "39640元",
    "info2": "",
    "no_prerequisites": true
  },
  {
    "id": "C132",
    "name": "国际商务",
    "info": "B4_A11",
    "extra_info": "39330元",
    "info2": "工商管理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C133",
    "name": "电影",
    "info": "B6_A11",
    "extra_info": "57009元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C134",
    "name": "酒店经营学",
    "info": "B2_A12",
    "extra_info": "30128元",
    "info2": "工商管理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C135",
    "name": "观光会展学",
    "info": "B27_A12",
    "extra_info": "30128元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C136",
    "name": "物流经营",
    "info": "B26_A12",
    "extra_info": "30128元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C137",
    "name": "美容艺术学",
    "info": "B5_A12",
    "extra_info": "40818元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C138",
    "name": "服装设计",
    "info": "B5_A12",
    "extra_info": "40818元",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C139",
    "name": "室内环境设计",
    "info": "B5_A12",
    "extra_info": "40818元",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C140",
    "name": "演艺公演艺术",
    "info": "B5_A12",
    "extra_info": "40818元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C141",
    "name": "实用音乐专业",
    "info": "B21_A12",
    "extra_info": "40818元",
    "info2": "音乐学学士",
    "no_prerequisites": false
  },
  {
    "id": "C142",
    "name": "机械汽车工学",
    "info": "B8_A12",
    "extra_info": "40818元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C143",
    "name": "氢系统工学",
    "info": "B9_A12",
    "extra_info": "40818元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C144",
    "name": "电气电子工学",
    "info": "B9_A12",
    "extra_info": "40818元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C145",
    "name": "建筑工学",
    "info": "B17_A12",
    "extra_info": "40818元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C146",
    "name": "AI·计算机工学",
    "info": "B7_A12",
    "extra_info": "40818元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C147",
    "name": "口腔卫生学",
    "info": "B12_A12",
    "extra_info": "39910元",
    "info2": "口腔卫生学学士",
    "no_prerequisites": false
  },
  {
    "id": "C148",
    "name": "美术学",
    "info": "B22_A13",
    "extra_info": "78378元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C149",
    "name": "音乐学",
    "info": "B21_A13",
    "extra_info": "78378元",
    "info2": "音乐学学士",
    "no_prerequisites": false
  },
  {
    "id": "C150",
    "name": "舞蹈学",
    "info": "B23_A13",
    "extra_info": "78378元",
    "info2": "舞蹈学学士",
    "no_prerequisites": false
  },
  {
    "id": "C151",
    "name": "观光经营",
    "info": "B1_A14",
    "extra_info": "25425元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C152",
    "name": "中文",
    "info": "B19_A14",
    "extra_info": "25425元",
    "info2": "文学学士",
    "no_prerequisites": false
  },
  {
    "id": "C153",
    "name": "舞蹈系",
    "info": "B23_A14",
    "extra_info": "37470元",
    "info2": "舞蹈学学士",
    "no_prerequisites": false
  },
  {
    "id": "C154",
    "name": "电气工学",
    "info": "B9_A14",
    "extra_info": "35025元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C155",
    "name": "汽车工学",
    "info": "B8_A14",
    "extra_info": "35025元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C156",
    "name": "医用工学",
    "info": "B43_A14",
    "extra_info": "35025元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C157",
    "name": "经营学",
    "info": "B1_A15",
    "extra_info": "33000元",
    "info2": "工商管理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C158",
    "name": "法学",
    "info": "B24_A15",
    "extra_info": "33000元",
    "info2": "法学学士",
    "no_prerequisites": false
  },
  {
    "id": "C159",
    "name": "食品营养专业",
    "info": "B25_A15",
    "extra_info": "37500元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C160",
    "name": "计算机",
    "info": "B7_A15",
    "extra_info": "37500元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C161",
    "name": "视觉设计",
    "info": "B5_A15",
    "extra_info": "41250元",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C162",
    "name": "人工智能软件",
    "info": "B7_A17",
    "extra_info": "江原大学",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C163",
    "name": "公共行政",
    "info": "B31_A17",
    "extra_info": "",
    "info2": "管理学士（公共行政）",
    "no_prerequisites": false
  },
  {
    "id": "C164",
    "name": "经济金融",
    "info": "B44_A17",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C165",
    "name": "幼儿教育",
    "info": "B36_A17",
    "extra_info": "",
    "info2": "教育学学士",
    "no_prerequisites": false
  },
  {
    "id": "C166",
    "name": "英语专业",
    "info": "B19_A17",
    "extra_info": "",
    "info2": "文学学士",
    "no_prerequisites": false
  },
  {
    "id": "C167",
    "name": "人类体育系",
    "info": "B29_A17",
    "extra_info": "",
    "info2": "体育学学士",
    "no_prerequisites": false
  },
  {
    "id": "C168",
    "name": "物理治疗系",
    "info": "B12_A17",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C169",
    "name": "眼睛光学系",
    "info": "B12_A17",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C170",
    "name": "食品营养学",
    "info": "B25_A17",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C171",
    "name": "国际经营学",
    "info": "B37_A16",
    "extra_info": "38785元",
    "info2": "工商管理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C172",
    "name": "传媒影像",
    "info": "B39_A16",
    "extra_info": "38785元",
    "info2": "传媒学学士",
    "no_prerequisites": false
  },
  {
    "id": "C173",
    "name": "幼儿教育",
    "info": "B36_A18",
    "extra_info": "31600元",
    "info2": "教育学学士",
    "no_prerequisites": false
  },
  {
    "id": "C174",
    "name": "医疗美容 ",
    "info": "B35_A18",
    "extra_info": "39660元",
    "info2": "保健学学士",
    "no_prerequisites": false
  },
  {
    "id": "C175",
    "name": "软件融合专业",
    "info": "B7_A18",
    "extra_info": "36200元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C176",
    "name": "实用音乐专业",
    "info": "B21_A18",
    "extra_info": "37130元",
    "info2": "音乐学学士",
    "no_prerequisites": false
  },
  {
    "id": "C177",
    "name": "视觉设计",
    "info": "B5_A18",
    "extra_info": "36200元",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C178",
    "name": "经营学",
    "info": "B1_A19",
    "extra_info": "36800元",
    "info2": "工商管理学学士",
    "no_prerequisites": true
  },
  {
    "id": "C179",
    "name": "儿童福祉",
    "info": "B41_A19",
    "extra_info": "35160元",
    "info2": "文学学士",
    "no_prerequisites": true
  },
  {
    "id": "C180",
    "name": "幼儿特殊教育",
    "info": "B42_A19",
    "extra_info": "36800元",
    "info2": "教育学士",
    "no_prerequisites": true
  },
  {
    "id": "C181",
    "name": "传媒影像",
    "info": "B39_A19",
    "extra_info": "35160元",
    "info2": "传媒学？新闻学？",
    "no_prerequisites": true
  },
  {
    "id": "C182",
    "name": "造景学",
    "info": "B32_A19",
    "extra_info": "42260元",
    "info2": "理学学士",
    "no_prerequisites": true
  },
  {
    "id": "C183",
    "name": "康复咨询",
    "info": "B12_A19",
    "extra_info": "42260元",
    "info2": "理学学位",
    "no_prerequisites": true
  },
  {
    "id": "C184",
    "name": "旅游管理",
    "info": "B34_A19",
    "extra_info": "35160元",
    "info2": "旅游学学士",
    "no_prerequisites": true
  },
  {
    "id": "C185",
    "name": "计算机工程",
    "info": "B7_A19",
    "extra_info": "47560元",
    "info2": "工学学士",
    "no_prerequisites": true
  },
  {
    "id": "C186",
    "name": "生活体育",
    "info": "B29_A19",
    "extra_info": "42260元",
    "info2": "体育学学士",
    "no_prerequisites": true
  },
  {
    "id": "C187",
    "name": "时尚设计",
    "info": "B5_A19",
    "extra_info": "47560元",
    "info2": "艺术学学士",
    "no_prerequisites": true
  },
  {
    "id": "C188",
    "name": "经营专业",
    "info": "B1_A20",
    "extra_info": "43000元",
    "info2": "工商管理学士",
    "no_prerequisites": false
  },
  {
    "id": "C189",
    "name": "智能资产经营系（会计专业）",
    "info": "B3_A20",
    "extra_info": "43000元",
    "info2": "工商管理学士",
    "no_prerequisites": false
  },
  {
    "id": "C190",
    "name": "计算机工学专业",
    "info": "B7_A20",
    "extra_info": "54000元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C191",
    "name": "经营学",
    "info": "B1_A21",
    "extra_info": "35240元",
    "info2": "工商管理学士",
    "no_prerequisites": true
  },
  {
    "id": "C192",
    "name": "人工智能学",
    "info": "B7_A21",
    "extra_info": "45680元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C193",
    "name": "产业设计专业",
    "info": "B99_A21",
    "extra_info": "45680元",
    "info2": "设计学士",
    "no_prerequisites": false
  },
  {
    "id": "C194",
    "name": "机械工学",
    "info": "B8_A21",
    "extra_info": "45680元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C195",
    "name": "航空乘务专业（观光经营学）",
    "info": "B45_A21",
    "extra_info": "42030元",
    "info2": "观光学学士",
    "no_prerequisites": false
  },
  {
    "id": "C196",
    "name": "全球文化交流（中语中文）",
    "info": "B99_A21",
    "extra_info": "35240元",
    "info2": "文学学士",
    "no_prerequisites": true
  },
  {
    "id": "C197",
    "name": "国际贸易学",
    "info": "B37_A22",
    "extra_info": "36632元",
    "info2": "工商管理学士",
    "no_prerequisites": false
  },
  {
    "id": "C198",
    "name": "航空服务",
    "info": "B45_A22",
    "extra_info": "36632元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C199",
    "name": "体育经营",
    "info": "B1_A22",
    "extra_info": "46212元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C200",
    "name": "音乐剧",
    "info": "B99_A22",
    "extra_info": "47686元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C201",
    "name": "护理学",
    "info": "B11_A23",
    "extra_info": "26812元",
    "info2": "护理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C202",
    "name": "*临床病理学",
    "info": "B12_A23",
    "extra_info": "                                                                                                                                                                                                                                                                                                          ",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C203",
    "name": "*体育科学",
    "info": "B29_A23",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C204",
    "name": "*医疗保健学",
    "info": "B12_A23",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C205",
    "name": "*保健学",
    "info": "B12_A23",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C206",
    "name": "*经营学",
    "info": "B1_A23",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C207",
    "name": "护理学",
    "info": "B11_A24",
    "extra_info": "40000元",
    "info2": "护理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C208",
    "name": "临床病理",
    "info": "B12_A24",
    "extra_info": "40000元",
    "info2": "临床病理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C209",
    "name": "制药工学",
    "info": "B10_A24",
    "extra_info": "40000元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C210",
    "name": "食品营养",
    "info": "B25_A24",
    "extra_info": "40000元",
    "info2": "理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C211",
    "name": "室内建筑设计",
    "info": "B5_A24",
    "extra_info": "40000元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C212",
    "name": "临床病理系",
    "info": "B12_A25",
    "extra_info": "54000元",
    "info2": "保健学士",
    "no_prerequisites": false
  },
  {
    "id": "C213",
    "name": "眼睛光学",
    "info": "B12_A25",
    "extra_info": "54000元",
    "info2": "眼睛光学士",
    "no_prerequisites": false
  },
  {
    "id": "C214",
    "name": "应急救护",
    "info": "B12_A25",
    "extra_info": "54000元",
    "info2": "保健学士",
    "no_prerequisites": false
  },
  {
    "id": "C215",
    "name": "放射线",
    "info": "B12_A25",
    "extra_info": "54000元",
    "info2": "理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C216",
    "name": "口腔卫生学",
    "info": "B12_A25",
    "extra_info": "54000元",
    "info2": "口腔卫生学学士",
    "no_prerequisites": false
  },
  {
    "id": "C217",
    "name": "物理治疗",
    "info": "B12_A25",
    "extra_info": "54000元",
    "info2": "物理治疗学士",
    "no_prerequisites": false
  },
  {
    "id": "C218",
    "name": "食品营养",
    "info": "B25_A25",
    "extra_info": "54000元",
    "info2": "理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C219",
    "name": "食品产业外食",
    "info": "B25_A25",
    "extra_info": "54000元",
    "info2": "理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C220",
    "name": "保健环境安全",
    "info": "B12_A25",
    "extra_info": "54000元",
    "info2": "理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C221",
    "name": "美容化妆品科学",
    "info": "B12_A25",
    "extra_info": "54000元",
    "info2": "保健学士",
    "no_prerequisites": false
  },
  {
    "id": "C222",
    "name": "医疗工学",
    "info": "B43_A25",
    "extra_info": "54000元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C223",
    "name": "户外运动",
    "info": "B29_A25",
    "extra_info": "54000元",
    "info2": "体育学士",
    "no_prerequisites": false
  },
  {
    "id": "C224",
    "name": "医疗经营学",
    "info": "B13_A25",
    "extra_info": "54000元",
    "info2": "工商管理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C225",
    "name": "医疗宣传设计",
    "info": "B5_A25",
    "extra_info": "54000元",
    "info2": "美术学士",
    "no_prerequisites": false
  },
  {
    "id": "C226",
    "name": "儿童系",
    "info": "B41_A25",
    "extra_info": "54000元",
    "info2": "文学士",
    "no_prerequisites": false
  },
  {
    "id": "C227",
    "name": "幼儿教育系",
    "info": "B41_A25",
    "extra_info": "54000元",
    "info2": "文学士",
    "no_prerequisites": false
  },
  {
    "id": "C228",
    "name": "中毒康复福祉",
    "info": "B12_A25",
    "extra_info": "54000元",
    "info2": "文学士",
    "no_prerequisites": false
  },
  {
    "id": "C229",
    "name": "葬礼指导",
    "info": "B99_A25",
    "extra_info": "54000元",
    "info2": "保健学士",
    "no_prerequisites": false
  },
  {
    "id": "C230",
    "name": "医疗IT",
    "info": "B7_A25",
    "extra_info": "54000元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C231",
    "name": "大数据医疗融合",
    "info": "B7_A25",
    "extra_info": "54000元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C232",
    "name": "工商管理经营学",
    "info": "B1_A26",
    "extra_info": "29000元",
    "info2": "工商管理学学士",
    "no_prerequisites": true
  },
  {
    "id": "C233",
    "name": "游戏工程",
    "info": "B7_A26",
    "extra_info": "41000元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C234",
    "name": "美容护理",
    "info": "B12_A26",
    "extra_info": "39000元",
    "info2": "美容保健学士",
    "no_prerequisites": true
  },
  {
    "id": "C235",
    "name": "视觉设计",
    "info": "B5_A26",
    "extra_info": "45000元",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C236",
    "name": "服装设计",
    "info": "B5_A26",
    "extra_info": "41826元",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C237",
    "name": "新媒体传播",
    "info": "B20_A26",
    "extra_info": "29000元",
    "info2": "传播学士",
    "no_prerequisites": false
  },
  {
    "id": "C238",
    "name": "建筑学系",
    "info": "B17_A27",
    "extra_info": "36830元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C239",
    "name": "计算机工程系",
    "info": "B7_A27",
    "extra_info": "36830元",
    "info2": "工学学士",
    "no_prerequisites": true
  },
  {
    "id": "C240",
    "name": "电气工程系",
    "info": "B8_A27",
    "extra_info": "36830元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C241",
    "name": "眼视光学系",
    "info": "B12_A27",
    "extra_info": "34180元",
    "info2": "理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C242",
    "name": "伴侣动物学系",
    "info": "B99_A27",
    "extra_info": "36830元",
    "info2": "理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C243",
    "name": "运动医学系",
    "info": "B12_A27",
    "extra_info": "34180元",
    "info2": "体育学士",
    "no_prerequisites": false
  },
  {
    "id": "C244",
    "name": "美容美发学系",
    "info": "B28_A27",
    "extra_info": "36830元",
    "info2": "美容学士",
    "no_prerequisites": false
  },
  {
    "id": "C245",
    "name": "心理咨询学系",
    "info": "B99_A27",
    "extra_info": "31170元",
    "info2": "文学学士",
    "no_prerequisites": false
  },
  {
    "id": "C246",
    "name": "经营学系",
    "info": "B1_A27",
    "extra_info": "31170元",
    "info2": "经营学士",
    "no_prerequisites": true
  },
  {
    "id": "C247",
    "name": "生活体育学系",
    "info": "B29_A27",
    "extra_info": "34180元",
    "info2": "体育学士",
    "no_prerequisites": false
  },
  {
    "id": "C248",
    "name": "跆拳道学系",
    "info": "B29_A27",
    "extra_info": "34180元",
    "info2": "体育学士",
    "no_prerequisites": false
  },
  {
    "id": "C249",
    "name": "音乐剧实用音乐学系",
    "info": "B21_A27",
    "extra_info": "36830元",
    "info2": "音乐学士",
    "no_prerequisites": false
  },
  {
    "id": "C250",
    "name": "公演艺术舞蹈学系",
    "info": "B23_A27",
    "extra_info": "34180元",
    "info2": "舞蹈学士",
    "no_prerequisites": false
  },
  {
    "id": "C251",
    "name": "经营学",
    "info": "B1_A28",
    "extra_info": "38000元",
    "info2": "工商管理学士",
    "no_prerequisites": true
  },
  {
    "id": "C252",
    "name": "酒店观光经营",
    "info": "B2_A28",
    "extra_info": "38000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C253",
    "name": "建筑工学",
    "info": "B17_A28",
    "extra_info": "43000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C254",
    "name": "媒体设计影像",
    "info": "B6_A28",
    "extra_info": "43000元",
    "info2": "艺术学学士",
    "no_prerequisites": false
  },
  {
    "id": "C255",
    "name": "计算机工学",
    "info": "B7_A28",
    "extra_info": "43000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C256",
    "name": "物流系统",
    "info": "B99_A28",
    "extra_info": "38000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C257",
    "name": "游戏多媒体",
    "info": "B6_A28",
    "extra_info": "43000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C258",
    "name": "形象设计",
    "info": "B5_A28",
    "extra_info": "45000元",
    "info2": "艺术学学士",
    "no_prerequisites": false
  },
  {
    "id": "C259",
    "name": "国际商务",
    "info": "B37_A29",
    "extra_info": "63000元",
    "info2": "贸易学学士",
    "no_prerequisites": false
  },
  {
    "id": "C260",
    "name": "航空酒店管理",
    "info": "B45_A29",
    "extra_info": "63000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C261",
    "name": "经营学",
    "info": "B1_A29",
    "extra_info": "63000元",
    "info2": "工商管理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C262",
    "name": "计算机工学",
    "info": "B7_A29",
    "extra_info": "72000元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C263",
    "name": "化妆品美容学",
    "info": "B46_A29",
    "extra_info": "72000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C264",
    "name": "中国语言文学",
    "info": "B19_A31",
    "extra_info": "36000元",
    "info2": "",
    "no_prerequisites": true
  },
  {
    "id": "C265",
    "name": "经营学",
    "info": "B1_A31",
    "extra_info": "36000元",
    "info2": "工商管理学士",
    "no_prerequisites": true
  },
  {
    "id": "C266",
    "name": "教育学",
    "info": "B42_A31",
    "extra_info": "36000元",
    "info2": "",
    "no_prerequisites": true
  },
  {
    "id": "C267",
    "name": "美容设计",
    "info": "B5_A31",
    "extra_info": "50000元",
    "info2": "",
    "no_prerequisites": true
  },
  {
    "id": "C268",
    "name": "计算机科学",
    "info": "B7_A31",
    "extra_info": "46000元",
    "info2": "",
    "no_prerequisites": true
  },
  {
    "id": "C269",
    "name": "新时代媒体（媒体科学技术）",
    "info": "B8_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C270",
    "name": "生物化妆品工程学",
    "info": "B10_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C271",
    "name": "韩国语言文学",
    "info": "B19_A31",
    "extra_info": "36000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C272",
    "name": "英国语言文学",
    "info": "B19_A31",
    "extra_info": "36000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C273",
    "name": "旅游开发",
    "info": "B34_A31",
    "extra_info": "36000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C274",
    "name": "公共管理",
    "info": "B47_A31",
    "extra_info": "36000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C275",
    "name": "行政学",
    "info": "B31_A31",
    "extra_info": "36000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C276",
    "name": "物流管理",
    "info": "B99_A31",
    "extra_info": "36000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C277",
    "name": "产品管理工程",
    "info": "B99_A31",
    "extra_info": "36000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C278",
    "name": "信息通信工程",
    "info": "B7_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C279",
    "name": "媒体软件",
    "info": "B7_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C280",
    "name": "城市设计信息工程",
    "info": "B9_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C281",
    "name": "音乐学",
    "info": "B21_A31",
    "extra_info": "50000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C282",
    "name": "美容设计",
    "info": "B5_A31",
    "extra_info": "50000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C283",
    "name": "应用音乐",
    "info": "B21_A31",
    "extra_info": "50000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C284",
    "name": "戏剧与电影",
    "info": "B6_A31",
    "extra_info": "50000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C285",
    "name": "表演艺术",
    "info": "B99_A31",
    "extra_info": "50000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C286",
    "name": "商谈心理学",
    "info": "B99_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C287",
    "name": "教育学",
    "info": "B42_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C288",
    "name": "幼儿教育",
    "info": "B36_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C289",
    "name": "体育教育",
    "info": "B42_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C290",
    "name": "戏剧与电影教育",
    "info": "B42_A31",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C292",
    "name": "（只有大三）福利商谈学-心里商谈学部",
    "info": "B99_A4",
    "extra_info": "",
    "info2": "心理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C293",
    "name": "（只有大三）福利商谈学-社会福利学部",
    "info": "B99_A4",
    "extra_info": "",
    "info2": "社会福利学学士",
    "no_prerequisites": false
  },
  {
    "id": "C294",
    "name": "国际通商学",
    "info": "B37_A5",
    "extra_info": "52400元",
    "info2": "工商管理学学士",
    "no_prerequisites": false
  },
  {
    "id": "C295",
    "name": "数据科学专业",
    "info": "B7_A5",
    "extra_info": "52400元",
    "info2": "工学学士",
    "no_prerequisites": false
  },
  {
    "id": "C296",
    "name": "多媒体设计",
    "info": "B5_A17",
    "extra_info": "22000元",
    "info2": "设计学学士",
    "no_prerequisites": false
  },
  {
    "id": "C291",
    "name": "经营学",
    "info": "B42_A32",
    "extra_info": "34000元",
    "info2": "工商管理学士",
    "no_prerequisites": false
  },
  {
    "id": "C297",
    "name": "（只有大三）网络漫画与动画",
    "info": "B5_A26",
    "extra_info": "41826元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C298",
    "name": "AI图形内容学",
    "info": "B7_A12",
    "extra_info": "42612元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C299",
    "name": "动画设计学",
    "info": "B5_A12",
    "extra_info": "42612元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C300",
    "name": "游戏VR学",
    "info": "B7_A12",
    "extra_info": "42612元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C301",
    "name": "网络漫画学",
    "info": "B5_A12",
    "extra_info": "42612元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C302",
    "name": "K-POP专业",
    "info": "B23_A12",
    "extra_info": "42612元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C303",
    "name": "广播摄影传媒",
    "info": "B20_A12",
    "extra_info": "33324元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C304",
    "name": "烹饪艺术学部",
    "info": "B99_A12",
    "extra_info": "40850元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C305",
    "name": "航空观光学",
    "info": "B45_A12",
    "extra_info": "31452元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C306",
    "name": "不动产学",
    "info": "B99_A12",
    "extra_info": "31452元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C307",
    "name": "社会福利",
    "info": "B99_A12",
    "extra_info": "31452元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C308",
    "name": "保健学",
    "info": "B12_A12",
    "extra_info": "33324元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C309",
    "name": "儿童·家庭商谈学",
    "info": "B41_A12",
    "extra_info": "31452元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C310",
    "name": "美容健康管理",
    "info": "B46_A12",
    "extra_info": "33324元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C311",
    "name": "健康烹饪创业学",
    "info": "B99_A12",
    "extra_info": "40850元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C312",
    "name": "老年康复学",
    "info": "B12_A12",
    "extra_info": "33324元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C313",
    "name": "人文文化融合学",
    "info": "B48_A12",
    "extra_info": "31452元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C314",
    "name": "老人福利商谈学",
    "info": "B99_A12",
    "extra_info": "31452元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C315",
    "name": "护理学（本学期不开放）",
    "info": "B11_A12",
    "extra_info": "41662元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C316",
    "name": "物理治疗学（本学期不开放（",
    "info": "B12_A12",
    "extra_info": "41662元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C317",
    "name": "休闲体育观光",
    "info": "B29_A12",
    "extra_info": "38215元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C318",
    "name": "跆拳道学",
    "info": "B29_A12",
    "extra_info": "38215元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C319",
    "name": "东洋武艺学",
    "info": "B29_A12",
    "extra_info": "38215元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C320",
    "name": "警察行政学",
    "info": "B30_A12",
    "extra_info": "31452元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C321",
    "name": "国际学部",
    "info": "B99_A12",
    "extra_info": "31452元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C328",
    "name": "电子工学",
    "info": "B9_A14",
    "extra_info": "35025元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C329",
    "name": "机械工学",
    "info": "B8_A14",
    "extra_info": "35025元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C330",
    "name": "视觉设计",
    "info": "B5_A14",
    "extra_info": "37470元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C331",
    "name": "时装设计",
    "info": "B5_A14",
    "extra_info": "37470元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C332",
    "name": "动漫影像",
    "info": "B5_A14",
    "extra_info": "37470元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C333",
    "name": "工业设计",
    "info": "B49_A14",
    "extra_info": "37470元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C334",
    "name": "声乐系",
    "info": "B21_A14",
    "extra_info": "37470元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C335",
    "name": "中文专业",
    "info": "B19_A14",
    "extra_info": "46000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C336",
    "name": "儿童青少年教育学",
    "info": "B41_A2",
    "extra_info": "41000元",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C337",
    "info": "",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C338",
    "info": "",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C339",
    "info": "",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C340",
    "info": "",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  },
  {
    "id": "C341",
    "info": "",
    "extra_info": "",
    "info2": "",
    "no_prerequisites": false
  }
];
